export default __webpack_public_path__ + "static/media/right scissors.17c485da.png";